module.exports = __webpack_public_path__ + "img/yod-beer-bearnana.c0b94336.png";